import React, { ReactNode } from 'react';
import { Skeleton, ErrorState, EmptyState, Pagination } from '@/components/ui';

export interface PageContentProps {
  children?: ReactNode;
  className?: string;
  isLoading?: boolean;
  error?: Error | any;
  isEmpty?: boolean;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyIcon?: string;
  onRetry?: () => void;
  // Pagination
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

/**
 * PageContent - Bọc khu vực dữ liệu chính (Table, CardList)
 * Hỗ trợ tự động hiển thị Skeleton, ErrorState, EmptyState, Pagination
 */
export function PageContent({ 
  children, 
  className = '',
  isLoading,
  error,
  isEmpty,
  emptyTitle,
  emptyDescription,
  emptyIcon,
  onRetry,
  currentPage,
  totalPages,
  onPageChange
}: PageContentProps) {
  if (error) {
    return (
      <div className={`w-full ${className}`}>
        <ErrorState 
          title="Đã xảy ra lỗi" 
          message={error?.message || 'Không thể tải dữ liệu'} 
          onRetry={onRetry || (() => window.location.reload())} 
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={`w-full space-y-4 ${className}`}>
        <Skeleton className="h-[400px] w-full rounded-md" />
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className={`w-full ${className}`}>
        <EmptyState 
          icon={emptyIcon || 'ri-inbox-2-line'} 
          title={emptyTitle || 'Không có dữ liệu'} 
          description={emptyDescription || 'Danh sách hiện tại đang trống.'} 
        />
      </div>
    );
  }

  return (
    <div className={`w-full flex flex-col gap-6 ${className}`}>
      {children}
      {currentPage !== undefined && totalPages !== undefined && totalPages > 1 && onPageChange && (
        <div className="flex justify-center mt-2">
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
      )}
    </div>
  );
}
